module.exports = __webpack_public_path__ + "media/12.d6040c63.mp3";